module.exports = __webpack_public_path__ + "fonts/NunitoSans_10pt-Black.f4fb8d76.ttf";